<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.itens"
            :tbody-tr-class="rowClass"
            class="table-materiais"
            hide-filters
            hide-pagination
            ref="Table"
        >
            <template v-slot:cell(actions)="{ index, item }">
                <template v-if="item.id && data.model.finalizada">
                    <rkm-button
                        v-if="!item.estornado || item.estornoSalvo"
                        :disabled="item.estornado"
                        :title="item.estornado ? 'Estornado' : 'Estornar'"
                        @click="handleEstorno(item)"
                        color="danger"
                        small
                    >
                        <rkm-icon icon="undo-alt" />
                    </rkm-button>

                    <rkm-button
                        v-else
                        title="Cancelar estorno"
                        @click="handleCancelEstorno(item)"
                        color="danger"
                        small
                    >
                        <rkm-icon icon="times" />
                    </rkm-button>
                </template>

                <rkm-button
                    v-else
                    @click.stop="remove(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>

            <template #afterTable>
                <div class="my-2">
                    <rkm-row>
                        <rkm-col>
                            <p>A linha em <span class="red">vermelho</span> representa um material que foi estornado.</p>
                        </rkm-col>

                        <rkm-col class="text-right">
                            <h6 class="font-weight-bold">Quantidade de materiais inclusa: {{ data.model.itens.length }}</h6>
                        </rkm-col>
                    </rkm-row>
                </div>
            </template>
        </rkm-table>
    </div>
</template>

<script>
export default {
    computed: {
        fields() {

            return [
                {
                    key: 'material.descricaoCompleta',
                    label: 'Material',
                    sortable: true,
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
    },
    methods: {
        handleEstorno(item) {

            this.showDeleteConfirmation(
                'Deseja realmente estornar o material?',
                async () => item.estornado = true
            )
        },
        handleCancelEstorno(item) {

            this.showDeleteConfirmation(
                'Deseja realmente cancelar o estorno?',
                async () => item.estornado = false
            )
        },
        remove(index) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o material?',
                async () => this.data.model.itens.splice(index, 1)
            )
        },
        rowClass(item, type) {

            if (type === 'row' && item && item.estornado) {

                return 'table-danger'
            }
        }
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>

<style scoped>
.table-materiais >>> .red { color: red; }
</style>